<template>
  <v-card>
    <v-card-title> 検収処理 </v-card-title>
    <v-card-text>
      <p>
        <span class="font-weight-bold"
        >・校了後の記事の状態を選択してください</span
        >
      </p>
      <div class="text-center">
        <v-btn-toggle v-model="result" class="mx-auto" tile dark>
          <v-btn
            value="publish"
            :color="result === 'publish' ? 'success' : 'grey lighten-1'"
            large
          >
            公開
          </v-btn>

          <v-btn
            value="close"
            :color="result === 'close' ? 'error' : 'grey lighten-1'"
            large
          >
            非公開
          </v-btn>

          <v-btn
            value="draft"
            :color="result === 'draft' ? 'warning' : 'grey lighten-1'"
            large
          >
            下書き
          </v-btn>
        </v-btn-toggle>
      </div>
      <p class="mt-5 pt-3 caption">
        ※検収を完了すると以後の処理は無効にすることができません。
      </p>
      <div style="width: 60%; margin: 0 auto">
        <v-btn
          :disabled="result === null"
          class="font-weight-bold"
          color="primary"
          block
          tile
          depressed
          @click="completeInspection"
        >
          上記結果にて校了とする
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  filters: {},
  data () {
    return {
      result: null
    }
  },
  methods: {
    completeInspection () {
      if (confirm('本当に検収を完了しますか？')) {
        const payload = { result: this.result }
        this.$store.dispatch('PostEditor/completeInspection', payload)
        this.completeDialog = false
        this.$emit('close-complete-dialog')
      }
    }
  }
}
</script>

<style scoped></style>
